import * as moment from 'moment'

import { databaseRef } from 'config'
import { isEducator } from 'services/user'

export const updatePatients = (role, email, emailKey, userId) => {
  return new Promise((resolve, reject) => {
    let key = ''
    let fieldName = ''
    let request

    const childRef = databaseRef.child('children')

    if (role === 'parent') {
      key = 'parents'
      fieldName = 'id_parent'

      request = childRef.orderByChild(`${key}/${emailKey}`).startAt(false)
    } else if (isEducator(role)) {
      key = 'educators'
      fieldName = 'id_educator'

      request = childRef.orderByChild(`${key}/${emailKey}/email`).equalTo(email)
    }

    request
      .once('value')
      .then(patientsTableData => {
        const updates = {}
        const patients = patientsTableData.val()

        for (const k of Object.keys(patients)) {
          if (isEducator(role)) {
            patients[k][key][userId] = { ...patients[k][key][emailKey] }
            patients[k][key][userId][fieldName] = userId
            patients[k][key][userId].patient_id = k
            patients[k][key][userId].enabled = true
            patients[k][key][userId].updated_at = moment().unix()
          } else {
            patients[k][key][userId] = true
          }

          patients[k].updated_at = moment().unix()
          patients[k][key][emailKey] = null

          updates[`patients/${k}`] = patients[k]
        }

        if (role === 'parent') {
          updates[`parents/${emailKey}`] = null

          databaseRef
            .child(`parents/${emailKey}`)
            .once('value')
            .then(parentsTableData => {
              const parent = parentsTableData.val()

              updates[`parents/${userId}`] = {
                ...parent,
                enabled: true,
                updated_at: moment().unix()
              }

              databaseRef.update(updates)
              resolve(updates)
            })
            .catch(error => {
              const { message } = error
              reject(message)
            })
        } else {
          databaseRef.update(updates)
          resolve(updates)
        }
      })
      .catch(error => {
        const { message } = error
        reject(message)
      })
  })
}



// WEBPACK FOOTER //
// ./src/store/user/updatePatients.ts